import { render, staticRenderFns } from "./PetHealth360Card.vue?vue&type=template&id=73ef29a8&scoped=true&"
import script from "./PetHealth360Card.vue?vue&type=script&lang=js&"
export * from "./PetHealth360Card.vue?vue&type=script&lang=js&"
import style0 from "./PetHealth360Card.vue?vue&type=style&index=0&id=73ef29a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ef29a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardTitle,VChip,VIcon,VSkeletonLoader})
